export const styles = {
  container:
    'tw-bg-white tw-border tw-border-neutral-200 tw-rounded tw-p-4 tw-shadow-sm tw-flex tw-flex-col tw-gap-4 tw-transition-shadow hover:tw-shadow',
  header: 'tw-flex tw-items-start tw-justify-between tw-gap-3',
  body: 'tw-flex tw-flex-col tw-gap-3 tw-min-w-0',
  entityLabel: 'tw-text-xs tw-font-medium tw-text-neutral-500 tw-mb-0.5',
  entityValue: 'tw-text-sm tw-font-medium tw-text-neutral-900',
  displayNameInput: 'tw-w-full',
  deleteButton: 'tw-shrink-0',
  deleteIcon: 'tw-text-neutral-500 hover:tw-text-danger-600 hover:tw-bg-danger-50',
};
